export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20fashion%20retail%20display%20with%20organized%20sneakers%20jackets%20bags%20and%20accessories%20on%20warm%20wooden%20shelving%20illuminated%20by%20soft%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%20clean%20Scandinavian%20aesthetic%20airy%20atmosphere%20warm%20terracotta%20and%20sand%20tones%20editorial%20product%20photography%20high%20detail%20no%20text%20no%20logos%20no%20people&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
          alt="OOPBuy Spreadsheet shopping guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <p className="text-accent-400 text-sm md:text-base font-medium tracking-wider mb-4 whitespace-nowrap">
              UPDATED FOR 2026 &bull; BEGINNER FRIENDLY
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
              OOPBuy Spreadsheet Guide
              <br />
              <span className="text-accent-400">The Complete System</span> for
              <br />
              Smart Shopping in 2026
            </h1>
            <p className="text-base md:text-lg text-background-200/90 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Discover how OOPBuy Spreadsheet works, why thousands of users rely on it, and how it compares to traditional shopping methods. Start optimizing your workflow today.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 font-semibold text-sm hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap text-center"
              >
                OOPBuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-all cursor-pointer whitespace-nowrap text-center"
              >
                Buy It Now
              </a>
            </div>

            <div className="mt-10 flex items-center gap-6 justify-center lg:justify-start">
              <div className="flex -space-x-3">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full border-2 border-background-50 bg-foreground-500 flex items-center justify-center text-background-50 text-xs font-bold"
                  >
                    <i className="ri-user-line"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-background-200/80 whitespace-nowrap">
                <strong className="text-background-50">Trusted by 10,000+</strong> smart shoppers
              </p>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-md">
              <div className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-3 h-3 rounded-full bg-red-400"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                  <div className="w-3 h-3 rounded-full bg-green-400"></div>
                  <span className="text-xs text-background-200/70 ml-2">spreadsheet.oopbuy</span>
                </div>
                <table className="w-full text-left text-sm">
                  <thead>
                    <tr className="border-b border-background-50/20">
                      <th className="pb-2 text-accent-400 font-medium text-xs">Product</th>
                      <th className="pb-2 text-accent-400 font-medium text-xs">Price</th>
                      <th className="pb-2 text-accent-400 font-medium text-xs">Status</th>
                    </tr>
                  </thead>
                  <tbody className="text-background-50/90">
                    <tr className="border-b border-background-50/10"><td className="py-2 text-xs">Nike Air Max</td><td className="py-2 text-xs">$89.99</td><td className="py-2 text-xs"><span className="text-green-400">Tracked</span></td></tr>
                    <tr className="border-b border-background-50/10"><td className="py-2 text-xs">Adidas Hoodie</td><td className="py-2 text-xs">$54.50</td><td className="py-2 text-xs"><span className="text-green-400">Shipped</span></td></tr>
                    <tr className="border-b border-background-50/10"><td className="py-2 text-xs">Levi's Jeans</td><td className="py-2 text-xs">$67.00</td><td className="py-2 text-xs"><span className="text-yellow-400">Pending</span></td></tr>
                    <tr><td className="py-2 text-xs">Puma T-Shirt</td><td className="py-2 text-xs">$24.99</td><td className="py-2 text-xs"><span className="text-green-400">Delivered</span></td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="w-10 h-10 flex items-center justify-center text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}